var _desc, _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSignupBannerZip(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "177px",
    height: "49px",
    viewBox: "0 0 177 49",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Banner-Zip ") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    x: "-2.3%",
    y: "-9.8%",
    width: "104.5%",
    height: "139.0%",
    filterUnits: "objectBoundingBox",
    id: "filter-1"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 8,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.231372549   0 0 0 0 0.274509804   0 0 0 0 0.164705882  0 0 0 0.15 0",
    type: "matrix",
    in: "shadowOffsetOuter1",
    result: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  }))), /*#__PURE__*/React.createElement("rect", {
    id: "path-2",
    x: 0.365702479,
    y: 5.71386719,
    width: 176.268595,
    height: 30.1199002,
    rx: 4
  }), /*#__PURE__*/React.createElement("rect", {
    id: "path-3",
    x: 18.6850136,
    y: 0.78515625,
    width: 140.427325,
    height: 39.4296875,
    rx: 4
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Modal/ZipResult/In-CA/Desktop-1440",
    transform: "translate(-452.000000, -125.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Banner-Zip-",
    filter: "url(#filter-1)",
    transform: "translate(452.000000, 125.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle-2"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#FFFFFF",
    fillRule: "evenodd",
    xlinkHref: "#path-2"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "#1B1B1B",
    strokeWidth: 3,
    x: 1.86570248,
    y: 7.21386719,
    width: 173.268595,
    height: 27.1199002,
    rx: 4
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-2",
    fill: "#000000",
    opacity: 0.0965806159,
    x: 13.0925257,
    y: 6.80913628,
    width: 150.814949,
    height: 27.9823589
  }), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle-2"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#FFFFFF",
    fillRule: "evenodd",
    xlinkHref: "#path-3"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "#1B1B1B",
    strokeWidth: 3,
    x: 20.1850136,
    y: 2.28515625,
    width: 137.427325,
    height: 36.4296875,
    rx: 4
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSignupBannerZip);
export default __webpack_public_path__ + "static/media/signup-banner-zip.e7be7d8eda4a6ba1905a5c58c383eadc.svg";
export { ForwardRef as ReactComponent };